/// <amd-module name="TFS/Admin/Groups/Pivots/MemberOf/Redux/MemberOfPivotReducers" />
import produce from "immer";
import { MemberOfPivotActions, MemberOfPivotActionTypes } from "TFS/Admin/Groups/Common/Redux/Actions/MemberOfPivotActions";
import { IMemberOfPivotState, PermissionsGraphGroup } from "TFS/Admin/Groups/Common/Contracts";
import { ObservableArray } from "VSS/Core/Observable";
import { SearchStatus, MemberOfOperation } from "TFS/Admin/Groups/Common/Constants";

export function memberOfReducer(state: IMemberOfPivotState, action: MemberOfPivotActions): IMemberOfPivotState {
    return produce(state || {}, draft => {
        switch (action.type) {
            case MemberOfPivotActionTypes.InitView: {
                draft.loading = true;
                (draft.groups = new ObservableArray<PermissionsGraphGroup>([])),
                    (draft.searchResult = {
                        keyword: "",
                        resultItems: [],
                        status: SearchStatus.None,
                        hasMore: false
                    });
                draft.showDeleteDialog = false;
                draft.showMessageCard = false;
                draft.selectGroupsPermissions = {};
                draft.invalidMembers = [];
                draft.validMembers = [];
                draft.multiOperationStatuses = [];
                break;
            }

            case MemberOfPivotActionTypes.InitialGroupFetch: {
                draft.groups.push(...action.payload);

                draft.loading = false;
                break;
            }

            case MemberOfPivotActionTypes.SearchMembers: {
                updateSearchStatus(draft, SearchStatus.Searching);
                break;
            }

            case MemberOfPivotActionTypes.UpdateSearchStatus: {
                updateSearchStatus(draft, action.payload);
                break;
            }

            case MemberOfPivotActionTypes.UpdateSearchResult: {
                updateSearchResult(draft, action.payload.keyword, action.payload.result, action.payload.hasMore);
                break;
            }

            case MemberOfPivotActionTypes.DeleteDialogCancel: {
                draft.selectedItem = undefined;
                draft.showDeleteDialog = false;
                break;
            }

            case MemberOfPivotActionTypes.DeleteMemberClick: {
                draft.selectedItem = action.payload;
                draft.showDeleteDialog = true;
                break;
            }

            case MemberOfPivotActionTypes.DismissMultiSummary: {
                draft.multiOperationStatuses = [];
                break;
            }

            case MemberOfPivotActionTypes.MemberOperationStatus: {
                var { selectedItems, operation, resultMessage, severity, multiOperationStatuses } = action.payload;
                draft.showMessageCard = true;
                draft.messageCardText = resultMessage;
                draft.messageCardSeverity = severity;

                if (multiOperationStatuses) {
                    draft.multiOperationStatuses = multiOperationStatuses;
                }

                draft.lastOperation = operation;

                switch (operation) {
                    case MemberOfOperation.Delete: {
                        if (selectedItems && selectedItems.length > 0) {
                            for (let selectedItem of selectedItems) {
                                const descriptor = selectedItem.descriptor;
                                var itemIndex = draft.groups.value.findIndex(x => x.descriptor === descriptor);
                                draft.groups.splice(itemIndex, 1);
                            }
                        }
                        draft.showDeleteDialog = false;
                        break;
                    }

                    case MemberOfOperation.Add: {
                        if (selectedItems && selectedItems.length > 0) {
                            draft.groups.push(...selectedItems);
                        }
                        break;
                    }
                }
                break;
            }

            case MemberOfPivotActionTypes.DismissMessageCard: {
                draft.showMessageCard = false;
                break;
            }

            case MemberOfPivotActionTypes.MemberOfGroupPermissionsSuccess: {
                const { permissions, isSelectedGroup, subjectDescriptor } = action.payload;

                if (isSelectedGroup) {
                    draft.selectGroupsPermissions[subjectDescriptor] = permissions;
                } else {
                    var itemIndex = draft.groups.value.findIndex(x => x.descriptor === subjectDescriptor);
                    if (itemIndex > -1) {
                        draft.groups.value[itemIndex].actionPermissions = permissions;
                    }
                }
                break;
            }

            case MemberOfPivotActionTypes.OpenAddMemberOfPanel: {
                draft.showAddMemberOfPanel = true;
                break;
            }

            case MemberOfPivotActionTypes.CloseAddMemberOfPanel: {
                draft.showAddMemberOfPanel = false;
                draft.invalidMembers = [];
                draft.validMembers = [];
                break;
            }

            case MemberOfPivotActionTypes.MembersLoadFailed: {
                draft.loading = false;
                break;
            }

            case MemberOfPivotActionTypes.AddInvalidMember: {
                draft.invalidMembers.push(action.payload.member);
                draft.validMembers.push(action.payload.member);
                break;
            }

            case MemberOfPivotActionTypes.AddValidMember: {
                draft.validMembers.push(action.payload.member);
                break;
            }

            case MemberOfPivotActionTypes.RemoveMembers: {
                draft.validMembers = draft.validMembers.filter(
                    entity => action.payload.members.filter(item => item.entityId === entity.entityId).length === 0
                );
                draft.invalidMembers = draft.invalidMembers.filter(
                    entity => action.payload.members.filter(item => item.entityId === entity.entityId).length === 0
                );
                break;
            }

            default:
                return state;
        }
    });
}

function updateSearchStatus(state: IMemberOfPivotState, searchStatus: SearchStatus) {
    const { searchResult } = state;
    if (!searchResult) {
        return;
    }
    if (searchStatus === SearchStatus.None) {
        searchResult.resultItems = [];
        searchResult.keyword = "";
    }
    searchResult.status = searchStatus;
}

function updateSearchResult(state: IMemberOfPivotState, keyword: string, results: any[], hasMore: boolean) {
    if (!keyword || !state.searchResult) {
        return;
    }
    state.searchResult = {
        keyword,
        resultItems: results,
        status: SearchStatus.Completed,
        hasMore
    };
}
